import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import genresService from "../services/genresService";

export const genresListResponce = createAsyncThunk(
  "genres/list",
  async (data) => {
    const res = await genresService.getGenres(data);
    return res?.data;
  }
);

export const createGenresResponce = createAsyncThunk(
  "genres/create",
  async (data) => {
    const res = await genresService.createGenres(data);
    return res;
  }
);

export const updateGenresResponce = createAsyncThunk(
  "genres/update",
  async (data) => {
    const res = await genresService.updateGenres(data);
    return res;
  }
);

export const deleteGenresResponce = createAsyncThunk(
  "genres/delete",
  async (id) => {
    const res = await genresService.deleteGenres(id);
    return { res, id };
  }
);

const genreSlice = createSlice({
  name: "genres",
  initialState: {
    genresResponce: [],
    createGenresResponce: [],
    createGenresError: "",
    updateGenresResponce: [],
    updateGenresError: "",
    deleteGenresResponce: [],
    deleteGenresError: "",
  },
  extraReducers: (builder) => {
    builder
      .addCase(genresListResponce.pending, (state) => {
        state.loading = true;
      })
      .addCase(genresListResponce.fulfilled, (state, action) => {
        state.loading = false;
        state.genresResponce = action.payload;
      })
      .addCase(genresListResponce.rejected, (state) => {
        state.loading = false;
      });

    // create

    builder
      .addCase(createGenresResponce.pending, (state) => {
        state.loading = true;
      })
      .addCase(createGenresResponce.fulfilled, (state, action) => {
        state.loading = false;
        state.createGenresResponce = action.payload;
      })
      .addCase(createGenresResponce.rejected, (state, action) => {
        state.loading = false;
        state.createGenresError = action?.error;
      });

    // update

    builder
      .addCase(updateGenresResponce.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateGenresResponce.fulfilled, (state, action) => {
        state.loading = false;
        state.updateGenresResponce = action.payload;
        state.genresResponce = state.genresResponce?.map((item) => {
          if (item?._id === action?.payload?.data?._id) {
            return {
              ...item,
              title: action?.payload?.data?.title,
              titlestring: action?.payload?.data?.titlestring,
              shortdesc: action?.payload?.data?.shortdesc,
            };
          }
          return item;
        });
      })
      .addCase(updateGenresResponce.rejected, (state, action) => {
        state.loading = false;
        state.updateGenresError = action?.error;
      });

    // delete

    builder
      .addCase(deleteGenresResponce.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteGenresResponce.fulfilled, (state, action) => {
        state.loading = false;
        state.deleteGenresResponce = action.payload?.res;
        state.genresResponce = state.genresResponce?.filter(
          (item) => item?._id !== action?.payload?.id
        );
      })
      .addCase(deleteGenresResponce.rejected, (state, action) => {
        state.loading = false;
        state.deleteGenresError = action?.error;
      });
  },
});

export default genreSlice.reducer;
